import './WorthWidget.scss';
import {formatCurrency} from '../../../utils';

const CurrencySparkline = ({points}) => {
    if (points.length < 2) return null;

    const nums = points.map(Number);
    const min = Math.min(...nums);
    const max = Math.max(...nums);
    const range = max - min || 1;
    const n = nums.length;

    const xs = nums.map((_, i) => (i / (n - 1)) * 120);
    const ys = nums.map(v => 2 + (1 - (v - min) / range) * 36);

    const polyPts = nums.map((_, i) => `${xs[i]},${ys[i]}`).join(' ');
    const areaD = `M ${xs[0]},${ys[0]} ` +
        nums.map((_, i) => `L ${xs[i]},${ys[i]}`).join(' ') +
        ` L ${xs[n - 1]},40 L ${xs[0]},40 Z`;

    return (
        <svg viewBox="0 0 120 40" className="worth-widget__sparkline-svg" preserveAspectRatio="none">
            <path d={areaD} fill="var(--primary)" opacity="0.15"/>
            <polyline
                points={polyPts}
                fill="none"
                stroke="var(--primary)"
                strokeWidth="1.5"
                strokeLinejoin="round"
                strokeLinecap="round"
            />
        </svg>
    );
};

const WorthWidget = ({worthData}) => {
    const currencies = Object.keys(worthData).sort();
    if (!currencies.length) return null;

    return (
        <div className="worth-widget">
            {currencies.map(c => {
                const {balanceToday, delta, sparkline} = worthData[c];
                const isPos = delta >= 0;
                return (
                    <div key={c} className="worth-widget__card">
                        <div className="worth-widget__currency-label">{c}</div>
                        <div className="worth-widget__balance">{formatCurrency(balanceToday, c)}</div>
                        <div className={`worth-widget__delta worth-widget__delta--${delta === 0 ? 'zero' : isPos ? 'pos' : 'neg'}`}>
                            {isPos ? '+' : '−'}{formatCurrency(Math.abs(delta), c)}
                        </div>
                        <div className="worth-widget__sparkline">
                            <CurrencySparkline points={sparkline ?? []}/>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default WorthWidget;
